import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { lazy, useState } from 'react';
import dayjs from 'dayjs';


import weekOfYear from 'dayjs/plugin/weekOfYear'
import advancedFormat from "dayjs/plugin/advancedFormat"
import MainLayout from './layout/MainLayout';
import IAAMLogin from './IAAMLogin';
import UserPermissionPage from './pages/UserPermission/UserPermissionPage';
import { ThemeProvider, createTheme } from '@mui/material';


dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)

const CaseReportPage = lazy(() => import("./pages/CaseReport/CaseReportPage"))
const LarvalReportPage = lazy(() => import("./pages/LarvalReport/LarvalReportPage"))
const ContainerReportPage = lazy(() => import("./pages/ContainerReport/ContainerReportPage"))
const ExecutionResultPage = lazy(() => import("./pages/ExecutionResult/ExecutionResultPage"))
const NotFoundPage = lazy(() => import("./pages/NotFound/NotFoundPage"))

const SettingContext = React.createContext()

const reducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            let _setting = JSON.parse(localStorage.getItem('trb.setting'))
            let isUserApproved = false
            const profile = action.profile
            if (profile) {
                // console.log(profile)
                if(profile?.userApproved !== undefined){
                    isUserApproved = profile.userApproved === "true" ? true : false
                    if (!_setting) {
                        let area_profile = "TH"
                        switch (profile.org_level) {
                            case "02":
                                area_profile = "DPC"
                                break
                            case "03":
                                area_profile = "PROV"
                                break
                            case "04":
                                area_profile = "AMPHUR"
                                break
                            case "05":
                                area_profile = "TAMBON"
                                break
                            default:
                                area_profile = "TH"

                        }
                        _setting = {
                            case_count: {
                                view: "area",
                                area: {
                                    data: "cumulative",
                                },
                                time: {
                                    data: "continuous",
                                },
                                comparison: {
                                    time_range: {
                                        selected: "W",
                                        W: {
                                            start: Number(dayjs().format('ww')).toString(),
                                            end: Number(dayjs().format('ww')).toString()
                                        },
                                        M: {
                                            start: dayjs().format('MM'),
                                            end: dayjs().format('MM')
                                        }
                                    },
                                    years: [Number(dayjs().format('YYYY')).toString()]
                                }
                            },
                            time_range: {
                                selected: "W",
                                W: {
                                    start: dayjs().format('YYYY-ww'),
                                    end: dayjs().format('YYYY-ww')
                                },
                                M: {
                                    start: dayjs().format('YYYY-MM'),
                                    end: dayjs().format('YYYY-MM')
                                },
                            },
                            display: {
                                selected: "area",
                                area: {
                                    selected: area_profile,
                                    TH: "TH",
                                    TH_NAME: "ประเทศไทย",
                                    DPC: profile.dpc_code,
                                    DPC_NAME: profile.dpc_name,
                                    PROV: profile.province_code,
                                    PROV_NAME: profile.province_name,
                                    AMPHUR: profile.amphur_code,
                                    AMPHUR_NAME: profile.amphur_name,
                                    TAMBON: profile.tambon_code,
                                    TAMBON_NAME: profile.tambon_name,
                                },
                                org: {
                                    selected: profile.org_id,
                                }
                            }
                        }
                    }
                }
                else{
                    window.location.href = `${process.env.REACT_APP_IAAMREG_HOST}`
                }
            }
            localStorage.setItem('trb.setting', JSON.stringify(_setting));
            return {
                ...state,
                isAuthenticated: true,
                isUserApproved: isUserApproved,
                setting: _setting,
                profile: profile,
                iaam: action.iaam
            };
        case "LOGOUT":
            return {
                ...state,
                isAuthenticated: false,
                isUserApproved: false,
                setting: null,
                profile: null
            };
        case "ON_PAGE_CHANGE":
            return {
                ...state,
                page_selected: action.payload.page_selected
            };
        case "SUBMIT_SETTING":
            return {
                ...state,
                setting: action.payload
            };
        default:
            return state;
    }
};

const theme = createTheme({
    typography: {
        fontFamily: [
            'Noto Sans Thai',
        ].join(','),
    },
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    "&&.Mui-selected": {
                        backgroundColor: "#b73238",
                        color: "#fff"
                    },
                    "&&.MuiMenuItem-root:hover": {
                        backgroundColor: "#ffebee",
                        color: "#000"
                    }
                }
            }
        },
        // MuiAutocomplete: {
        //     styleOverrides: {
        //         listbox: {
        //             '& .MuiAutocomplete-option.Mui-focused': { 
        //                 backgroundColor: '#ffebee',
        //                 // color: "#000"
        //             },
        //             '& .MuiAutocomplete-option[aria-selected="true"]': { 
        //                 backgroundColor: '#ffebee',
        //                 // color: "#fff"
        //             },
        //             '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': { 
        //                 backgroundColor: '#ffebee',
        //                 // color: "#fff"
        //             }
        //         },
        //     }g
        // },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "&&.Mui-checked": {
                        color: "#b73238"
                    }
                }
            }
        },
        MuiPickersYear: {
            styleOverrides: {
                yearButton: {
                    "&&.Mui-selected": {
                        backgroundColor: "#b73238",
                        color: "#fff"
                    },
                }
            }
        },
        MuiPickersMonth: {
            styleOverrides: {
                monthButton: {
                    "&&.Mui-selected": {
                        backgroundColor: "#b73238",
                        color: "#fff"
                    },
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                switchBase:{
                    "&&.Mui-checked": {
                        color: "#b73238",
                        "&&+.MuiSwitch-track": {
                            backgroundColor: "#b73238"
                        },
                    },
                    
                }
            }
        }
    }
});

function App() {

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/" element={<NavWrapper />} >
                        <Route path="/" element={<LarvalReportPage />} />
                        <Route path="/case" element={<CaseReportPage />} />
                        <Route path="/larval" element={<LarvalReportPage />} />
                        <Route path="/container" element={<ContainerReportPage />} />
                        <Route path="/execution" element={<ExecutionResultPage />} />
                        <Route path="/*" element={<NotFoundPage />} />
                    </Route>
                </Routes>
            </Router>
        </ThemeProvider>

    );
}

function NavWrapper() {
    const location = useLocation();
    const initialState = {
        isAuthenticated: false,
        page_selected: location.pathname === "/" ? "larval" : location.pathname.split("/")[1],
        setting: null
    };

    const [state, dispatch] = React.useReducer(reducer, initialState);
    const [setting, setSetting] = useState(null);

    return (
        <SettingContext.Provider value={{ state, dispatch, setting, setSetting }}>
            {!state.isAuthenticated ? <IAAMLogin /> : state.isUserApproved ? <MainLayout /> : <UserPermissionPage />}
        </SettingContext.Provider>
    )
}
export { SettingContext }

export default App;
